var _defs, _rect, _rect2, _polygon, _rect3, _polygon2, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 650 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:#f5f3f5;}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 426.4922,
    y1: 332.7467,
    x2: 195.8633,
    y2: 332.7467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1477,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2305,
    stopColor: "#f5f3f5",
    stopOpacity: 0.9362
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3917,
    stopColor: "#f5f3f5",
    stopOpacity: 0.7691
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6151,
    stopColor: "#f5f3f5",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8895,
    stopColor: "#f5f3f5",
    stopOpacity: 0.1312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9825,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 195.8633,
    y1: 175.5169,
    x2: 195.8633,
    y2: 319.7923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1477,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2507,
    stopColor: "#f5f3f5",
    stopOpacity: 0.9049
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4677,
    stopColor: "#f5f3f5",
    stopOpacity: 0.6598
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7778,
    stopColor: "#f5f3f5",
    stopOpacity: 0.2712
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9825,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 17003.5036,
    y1: 18884.5548,
    x2: 16906.1403,
    y2: 18884.5548,
    gradientTransform: "translate(4405.2981 25263.6338) rotate(-147.1568)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1477,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2193,
    stopColor: "#f5f3f5",
    stopOpacity: 0.9569
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3436,
    stopColor: "#f5f3f5",
    stopOpacity: 0.8411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5057,
    stopColor: "#f5f3f5",
    stopOpacity: 0.653
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6993,
    stopColor: "#f5f3f5",
    stopOpacity: 0.3923
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9175,
    stopColor: "#f5f3f5",
    stopOpacity: 0.0641
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9579,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -204.2685,
    y1: 18884.5548,
    x2: -301.6313,
    y2: 18884.5548,
    gradientTransform: "matrix(0.5423, 0.8402, 0.8402, -0.5423, -15481.2794, 10656.7397)",
    xlinkHref: "#linear-gradient-3"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 195.8633,
    y: 328.3116,
    width: 230.6289,
    height: 8.8701
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 191.4282,
    y: 175.5169,
    width: 8.8701,
    height: 144.2754
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "458.572 337.182 426.492 337.182 426.492 328.312 449.702 328.312 449.702 171.688 200.298 171.688 200.298 175.517 191.428 175.517 191.428 162.818 458.572 162.818 458.572 337.182"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 347.3941,
    y: 197.878,
    width: 110.1611,
    height: 8.8699,
    transform: "matrix(0.8402, -0.5423, 0.5423, 0.8402, -45.3904, 250.6173)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "324.999 257.602 291.396 235.908 296.207 228.456 324.999 247.044 353.795 228.456 358.606 235.908 324.999 257.602"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 243.0921,
    y: 147.2326,
    width: 8.8699,
    height: 110.1606,
    transform: "translate(-56.6922 300.5516) rotate(-57.1567)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/Envelope.b2041da09abedabc4243bb29eaa6c5cc.svg";
export { ForwardRef as ReactComponent };